import { trim, isEqual } from 'lodash';
import type { Key } from 'react';
// import request, { ResponseData } from '@/services/requestV1';
import { observable, action, computed, makeObservable } from 'mobx';
import {
  defaultTablePageSize,
  defaultFetchAllPageSize,
  defaultPageSizeOptions,
} from '../constants/index';
import {
  IListResponse,
  IListBaseParams,
  OrderType,
  OrderShortType,
  IManagerModelFetchConfig,
} from '../types';
import { API_PREFIX } from './request';
import * as request from './request';
// import { defaultPaginationConfig } from '../constants/index';

// export const fetchAllParams: IListBaseParams = {
//   sort: "updateTime",
//   order: OrderShortType.Descend,
//   pageNo: 1,
//   pageSize: defaultFetchAllPageSize,
//   search: "",
// };

export class BaseManagerModel<
  // 列表项的类型
  IItem,
> {
  url: string;
  fetchConfig: IManagerModelFetchConfig | null = null;

  @observable current = 1;
  @observable search = '';
  @observable pageSize = defaultTablePageSize;
  @observable sorter: Key | undefined = undefined;
  @observable order: OrderShortType | undefined = undefined;
  @observable total = 0;
  @observable fetchAll: boolean = false;
  @observable.ref data: IItem[] = [];
  @observable.ref pageSizeOptions = defaultPageSizeOptions;

  // 分组，实际上也是过滤，但因为在视觉上分组一般在左侧栏，这里单独处理。
  @observable.ref groups: number[] = [];

  // 过滤参数
  @observable.ref filters: IKeyValues<any[]> = {};

  @observable isListLoading: boolean = false;

  @observable isDeleteLoading: boolean = false;

  @observable isUpdateLoading: boolean = false;

  get baseUrl(): string {
    return `${this.url}`;
  }

  @computed
  get searchParams(): IListBaseParams {
    const params: IListBaseParams = {
      sortName: this.sorter,
      sortOrder: this.order,
      page: this.current,
      pageSize: this.fetchAll ? defaultFetchAllPageSize : this.pageSize,
      search: trim(this.search),
    };

    const filterParams: IKeyValues<string> = {};

    Object.keys(this.filters).forEach((it) => {
      const item = it;
      const filterValues = this.filters[item];
      if (filterValues) {
        if (Array.isArray(filterValues)) {
          if (filterValues.length > 0) {
            filterParams[item] = filterValues.join(',');
          }
        } else {
          filterParams[item] = filterValues;
        }
      }
    });

    if (this.groups.length > 0) {
      filterParams['groupId'] = this.groups.join(',');
    }

    return {
      ...filterParams,
      ...params,
      // @ts-ignore
    };
  }

  // @computed
  // get tableOrder() {
  //   if (this.sorter) {
  //     return {
  //       [this.sorter]:
  //         this.order === OrderShortType.Ascend
  //           ? OrderType.Ascend
  //           : OrderType.Descend,
  //     };
  //   }
  // }

  // @computed
  // get baseTablePagination() {
  //   return {
  //     ...defaultPaginationConfig,
  //     pageSizeOptions: this.pageSizeOptions,
  //     current: this.current,
  //     pageSize: this.pageSize,
  //     total: this.total,
  //   };
  // }
  // @computed
  // get tablePagination() {
  //   return {
  //     ...this.baseTablePagination,
  //     onChange: this.handleTablePagination,
  //   };
  // }

  @action
  setIsListLoading(v: boolean) {
    this.isListLoading = v;
  }

  @action
  setIsDeleteLoading(v: boolean) {
    this.isDeleteLoading = v;
  }

  @action
  setIsUpdateLoading(v: boolean) {
    this.isUpdateLoading = v;
  }

  @action
  setGroups(groups: number[]) {
    if (isEqual(this.groups, groups)) {
      return;
    }
    this.groups = groups;
    this.current = 1;
  }

  @action
  setCurrent(current: number) {
    this.current = current;
  }

  @action
  setSearch(search: string) {
    this.search = search;
    this.current = 1;
  }

  @action
  setPageSize(size: number) {
    // 切换页码时此函数也会被调用，故需要判断是否有更新
    if (size === this.pageSize) {
      return;
    }
    this.pageSize = size;

    this.current = 1;
  }

  @action
  setSorter(sorter: Key | undefined) {
    this.sorter = sorter;
  }

  @action
  setOrder(order: OrderShortType | undefined) {
    this.order = order;
  }

  @action
  setTotal(total: number) {
    this.total = total;
  }

  @action
  setData(data: IItem[]) {
    this.data = data;
  }

  @action
  setFetchAll(fetchAll: boolean) {
    this.fetchAll = fetchAll;
  }

  @action
  setPageSizeOptions(pageSizeOptions: string[]) {
    this.pageSizeOptions = pageSizeOptions;
  }

  @action
  setFilters(filters: IKeyValues<any[]>) {
    this.filters = filters;
  }

  changeFilter(name: string, value: string[]) {
    this.setFilters({ ...this.filters, [name]: value });
  }

  private handleTablePagination = (current: number, pageSize?: number) => {
    this.setCurrent(current);
    if (pageSize) {
      this.setPageSize(pageSize);
    }
  };

  list() {
    this.setIsListLoading(true);
    let url = `${this.baseUrl}`;
    let method = 'get';
    if (this.fetchConfig?.list) {
      url = this.fetchConfig?.list.url;
      method = this.fetchConfig?.list.method;
    }
    console.log('====search', url, this.searchParams);
    return request[method.toLocaleLowerCase() as 'get' | 'post'](
      url,
      this.searchParams,
    ).then(
      (res: IListResponse<IItem>) => {
        console.log('======++++', res);
        const { count, rows } = res;
        this.setIsListLoading(false);
        this.setTotal(count);
        this.setData(rows);
        return { total: count, items: rows };
      },
      (error) => {
        this.setIsListLoading(false);
        return Promise.reject(error);
      },
    );
  }

  delete(id: string) {
    this.setIsDeleteLoading(true);
    let url = `${this.baseUrl}/${id}`;
    let method = 'delete';
    if (this.fetchConfig?.delete) {
      url = this.fetchConfig?.delete.url;
      method = this.fetchConfig?.delete.method;
    }
    return request[method.toLocaleLowerCase() as 'get' | 'post'](url, {
      id: id.toString(),
      status: 0,
    }).then(
      (res) => {
        this.setIsDeleteLoading(false);
        return res;
      },
      (error) => {
        this.setIsDeleteLoading(false);
        return Promise.reject(error);
      },
    );
  }

  disable(id: string) {
    this.setIsDeleteLoading(true);
    let url = `${this.baseUrl}/${id}`;
    let method = 'PATCH';
    if (this.fetchConfig?.delete) {
      url = this.fetchConfig?.delete.url;
      method = this.fetchConfig?.delete.method;
    }
    return request[method.toLocaleLowerCase() as 'get' | 'post'](url, {
      enabled: false,
    }).then(
      (res) => {
        this.setIsDeleteLoading(false);
        return res;
      },
      (error) => {
        this.setIsDeleteLoading(false);
        return Promise.reject(error);
      },
    );
  }

  enable(id: string) {
    this.setIsDeleteLoading(true);
    let url = `${this.baseUrl}/${id}`;
    let method = 'PATCH';
    if (this.fetchConfig?.delete) {
      url = this.fetchConfig?.delete.url;
      method = this.fetchConfig?.delete.method;
    }
    return request[method.toLocaleLowerCase() as 'get' | 'post'](url, {
      enabled: true,
    }).then(
      (res) => {
        this.setIsDeleteLoading(false);
        return res;
      },
      (error) => {
        this.setIsDeleteLoading(false);
        return Promise.reject(error);
      },
    );
  }

  init() {
    this.setCurrent(1);
    this.setSearch('');
  }

  constructor(url: string, fetchConfig?: IManagerModelFetchConfig) {
    makeObservable(this);
    this.url = url;
    if (fetchConfig) {
      this.fetchConfig = fetchConfig;
    }
  }
}
